/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui icons
import Favorite from "@material-ui/icons/Favorite";
import ChatBubble from "@material-ui/icons/ChatBubble";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Danger from "components/Typography/Danger.js";

import christian from "assets/img/faces/christian.jpg";

import cardsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

const style = {
  ...cardsStyle,
};

const useStyles = makeStyles(style);

export default function CardExampleCardTrending() {
  const classes = useStyles();
  return (
    <Card>
      <CardBody>
        <Danger>
          <h6 className={classes.cardCategory}>TRENDING</h6>
        </Danger>
        <h4 className={classes.cardTitle}>
          <a href="#pablo" onClick={(e) => e.preventDefault()}>
            To Grow Your Business Start Focusing on Your Employees
          </a>
        </h4>
      </CardBody>
      <CardFooter>
        <div className={classes.author}>
          <a href="#pablo" onClick={(e) => e.preventDefault()}>
            <img
              src={christian}
              alt="..."
              className={`${classes.imgRaised} ${classes.avatar}`}
            />
            <span>Lord Alex</span>
          </a>
        </div>
        <div className={`${classes.stats} ${classes.mlAuto}`}>
          <Favorite />
          345 ·
          <ChatBubble />
          45
        </div>
      </CardFooter>
    </Card>
  );
}
